import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
    selector: 'lib-image-list-option',
    templateUrl: './image-list-option.component.html',
    styleUrls: ['./image-list-option.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImageListOptionComponent implements OnInit {
  @Output() clicked = new EventEmitter();
  @ViewChild('label', { static: true }) label: ElementRef<HTMLElement>;
  @ViewChild('icon', { static: true }) icon: ElementRef<HTMLElement>;
  @ViewChild('img', { static: true }) img: ElementRef<HTMLElement>;
  @Input() value;
  selected = false;
  svgIcon = null;

  get currentLabel() {
    return this.label?.nativeElement.innerText;
  }

  _isSvg = null;

  get isSvg() {
    if (typeof this._isSvg !== 'boolean') {
      this.svgIcon = this.icon.nativeElement
        .querySelector('[svgicon]')
        ?.getAttribute('svgicon');
      this._isSvg = !!this.svgIcon;
    }
    return this._isSvg;
  }

  get currentIcon() {
    if (this.isSvg) {
      return this.svgIcon;
    }
    return this.icon?.nativeElement.innerText;
  }

  get currentImage() {
    return (this.img?.nativeElement.firstChild as HTMLImageElement)?.src;
  }

  constructor() {}

  @HostBinding('click') wasClicked() {
    this.clicked.emit(true);
  }

  ngOnInit(): void {}
}
